import React from "react";
import { TrendInfo } from "../../types";
import Charts from "../CurrencyChart";
import { Grid, Header } from "semantic-ui-react";
import styles from "./styles.module.scss";
import { mapToChartValues } from "../../utils/chartFormat";

interface Props {
  cfTrend?: TrendInfo;
  projectedCfTrend?: TrendInfo;
  mtmTrend?: TrendInfo;
  varTrend?: TrendInfo;
  projectedVarTrend?: TrendInfo;
}

const ClearingFundCharts = ({
  cfTrend,
  projectedCfTrend,
  mtmTrend,
  varTrend,
  projectedVarTrend,
}: Props) => {
  return (
    <div>
      <Grid columns={3} padded>
        <Grid.Column>
          <Header as="h3" dividing>
            Clearing Fund
          </Header>
          <div className={styles.chart} id={"cf-chart"}>
            {cfTrend && (
              <Charts
                data={mapToChartValues(cfTrend?.totalRequirement.values)}
                projectedData={mapToChartValues(
                  projectedCfTrend?.totalRequirement.values
                )}
              />
            )}
          </div>
        </Grid.Column>
        <Grid.Column>
          <Header as="h3" dividing>
            MTM
          </Header>
          <div className={styles.chart} id={"mtm-chart"}>
            {mtmTrend && (
              <Charts
                data={mapToChartValues(mtmTrend?.totalRequirement.values)}
              />
            )}
          </div>
        </Grid.Column>
        <Grid.Column>
          <Header as="h3" dividing>
            VAR
          </Header>
          <div className={styles.chart} id={"var-chart"}>
            {varTrend && (
              <Charts
                data={mapToChartValues(varTrend?.totalRequirement.values)}
                projectedData={mapToChartValues(
                  projectedVarTrend?.totalRequirement.values
                )}
              />
            )}
          </div>
        </Grid.Column>
      </Grid>
    </div>
  );
};

export default ClearingFundCharts;
